import { Fragment, FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    Container,
    Divider,
    Stack,
    SvgIcon,
    Typography,
    useTheme,
} from '@mui/material';
import { FormDrawer } from '@starjack/shared-components';
import { CardListRow } from '@/components/Card/CardListRow';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@heroicons/react/24/solid/PencilIcon';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetConfigurationsQuery } from '@/api/v2/configurations';
import { Webshop } from '@/models/webshop';
import { WebshopDrawerContent } from '@/pages/standardShops/components/WebshopDrawerContent';

export const WebshopsPageContent: FunctionComponent = () => {
    const theme = useTheme();
    const {
        liftOperatorData: { liftOperatorId },
    } = useAuthentication();
    const { data: webshops } = useGetConfigurationsQuery({
        liftOperatorId: liftOperatorId,
    });

    const [drawerConfig, setDrawerConfig] = useState<{
        isOpen: boolean;
        webshop: Webshop;
    }>(null);

    const onCloseDrawer = () => {
        setDrawerConfig((prevState) => ({
            ...prevState,
            isOpen: false,
        }));
    };

    return (
        <>
            <Typography
                sx={{
                    mb: 8,
                }}
                variant='h4'
            >
                Webshopverwaltung
            </Typography>
            <Stack spacing={theme.page.verticalSpacing}>
                <Container
                    sx={{
                        mt: 3,
                        ml: 'unset',
                    }}
                    maxWidth='lg'
                >
                    <Card>
                        <CardContent
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant='h6'>
                                Angelegte Webshops
                            </Typography>
                        </CardContent>
                        <Divider
                            sx={{
                                width: '100%',
                            }}
                        />

                        {webshops?.map((webshop, index) => (
                            <Fragment key={index}>
                                <CardListRow
                                    sx={{
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography>
                                        {webshop.vanityIdentifier}
                                    </Typography>

                                    <Stack
                                        sx={{
                                            ml: 'auto',
                                            alignItems: 'center',
                                        }}
                                        direction='row'
                                        spacing={2}
                                    >
                                        <IconButton
                                            aria-label='Bearbeiten'
                                            onClick={() => {
                                                setDrawerConfig({
                                                    isOpen: true,
                                                    webshop,
                                                });
                                            }}
                                        >
                                            <SvgIcon>
                                                <EditIcon />
                                            </SvgIcon>
                                        </IconButton>
                                    </Stack>
                                </CardListRow>

                                {index < webshops.length - 1 && (
                                    <Divider
                                        sx={{
                                            width: '100%',
                                        }}
                                    />
                                )}
                            </Fragment>
                        ))}
                    </Card>

                    <FormDrawer
                        anchor='right'
                        open={drawerConfig?.isOpen}
                        onClose={onCloseDrawer}
                    >
                        <WebshopDrawerContent
                            webshop={drawerConfig?.webshop}
                            onClose={onCloseDrawer}
                        />
                    </FormDrawer>
                </Container>
            </Stack>
        </>
    );
};
